export const SERVER_URL = 'https://fastcampus-chat.net';
export const USER_DEFAULT_IMG =
  'https://github.com/turkey-kim/8lack/assets/83493231/b681ebef-d1f7-4cb1-a331-c2dc7f7bb2a3';
